define("shared/components/shared/post-tagging/tag-dropdown-item", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <li
    aria-label="{{@tag.name}}{{if @isSelected ', selected'}}"
    class={{concat-classes "cPT__tag-dropdown__item" (if @isSelected "selected") (if this.isDisabled "is--disabled")}}
    data-test-id="post-tagging-tag-item"
    tabindex="0"
    {{on "click" this.onTagItemClicked}}
    {{on "keydown" this.onTagItemKeydown}}
  >
    {{#if this.isRenaming}}
      {{svg-jar "edit" class="o--icon cPT__icon u--m__r__sm"}}
    {{else if @isSelected}}
      {{svg-jar "verified-solid" class="o--icon cPT__icon u--m__r__sm cPT__color-primary"}}
    {{else}}
      {{svg-jar "verified" class="o--icon cPT__icon u--m__r__sm"}}
    {{/if}}
  
    <Shared::PostTagging::ColorCircle @class="u--m__r__sm" @color={{@tag.data.color}} />
  
    {{#if this.isRenaming}}
      <Input
        @value={{this.newTagName}}
        class="cPT__tag-dropdown__input--rename"
        data-test-id="post-tagging-rename-input"
        {{autofocus}}
        {{on "keydown" this.handleRenameInput}}
        {{on "click" this.stopPropagation}}
      />
  
      <Shared::Ui::Button
        @additional="circle"
        @onClick={{this.handleSubmitRename}}
        @variant="unstyled"
        class="u--m__l__xs"
        data-test-id="post-tagging-rename-submit-button"
        tabindex="0"
      >
        {{svg-jar "check" class="o--icon"}}
      </Shared::Ui::Button>
    {{else}}
      <span class="tag-name u--m__r__xs">{{@tag.name}}</span>
    {{/if}}
    <BasicDropdown
      @horizontalPosition="right"
      @onClose={{this.onDeleteDropdownClosed}}
      @onOpen={{this.onDeleteDropdownOpen}}
      as |actionsDD|
    >
      <actionsDD.Trigger
        data-test-id="post-tagging-tag-item-actions-trigger"
        tabindex="-1"
        {{on "click" this.stopPropagation}}
      >
        {{#unless this.isRenaming}}
          <Shared::Ui::Button
            @additional="circle"
            @variant={{if this.isRenaming "mute" "unstyled"}}
            class="cPT__text-primary"
          >
            {{svg-jar "ellipsis-h" class="o--icon"}}
          </Shared::Ui::Button>
        {{/unless}}
      </actionsDD.Trigger>
      <actionsDD.Content class="cPT__tag-dropdown__content-delete" data-test-id="post-tagging-tag-item-actions-content">
        <Shared::Ui::Button
          @onClick={{fn this.onRenameClicked actionsDD}}
          @variant="unstyled"
          class="cPT__tag-dropdown__item cPT__text-primary"
          data-test-id="post-tagging-rename-button"
          tabindex="0"
        >
          {{svg-jar "edit" class="o--icon cPT__icon u--m__r__sm"}}
          {{t "post-tagging.tags.rename"}}
        </Shared::Ui::Button>
  
        <Shared::Ui::Button
          @onClick={{fn @deleteTag @tag}}
          @variant="unstyled"
          class="cPT__tag-dropdown__item cPT__text-primary"
          data-test-id="post-tagging-delete-button"
          tabindex="0"
        >
          {{svg-jar "trash" class="o--icon cPT__icon u--m__r__sm"}}
          {{t "post-tagging.tags.delete"}}
        </Shared::Ui::Button>
      </actionsDD.Content>
    </BasicDropdown>
  </li>
  */
  {
    "id": "06CHLGBO",
    "block": "[[[11,\"li\"],[16,\"aria-label\",[29,[[30,1,[\"name\"]],[52,[30,2],\", selected\"]]]],[16,0,[28,[37,1],[\"cPT__tag-dropdown__item\",[52,[30,2],\"selected\"],[52,[30,0,[\"isDisabled\"]],\"is--disabled\"]],null]],[24,\"data-test-id\",\"post-tagging-tag-item\"],[24,\"tabindex\",\"0\"],[4,[38,2],[\"click\",[30,0,[\"onTagItemClicked\"]]],null],[4,[38,2],[\"keydown\",[30,0,[\"onTagItemKeydown\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"isRenaming\"]],[[[1,\"    \"],[1,[28,[35,3],[\"edit\"],[[\"class\"],[\"o--icon cPT__icon u--m__r__sm\"]]]],[1,\"\\n\"]],[]],[[[41,[30,2],[[[1,\"    \"],[1,[28,[35,3],[\"verified-solid\"],[[\"class\"],[\"o--icon cPT__icon u--m__r__sm cPT__color-primary\"]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[1,[28,[35,3],[\"verified\"],[[\"class\"],[\"o--icon cPT__icon u--m__r__sm\"]]]],[1,\"\\n  \"]],[]]]],[]]],[1,\"\\n  \"],[8,[39,4],null,[[\"@class\",\"@color\"],[\"u--m__r__sm\",[30,1,[\"data\",\"color\"]]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"isRenaming\"]],[[[1,\"    \"],[8,[39,5],[[24,0,\"cPT__tag-dropdown__input--rename\"],[24,\"data-test-id\",\"post-tagging-rename-input\"],[4,[38,6],null,null],[4,[38,2],[\"keydown\",[30,0,[\"handleRenameInput\"]]],null],[4,[38,2],[\"click\",[30,0,[\"stopPropagation\"]]],null]],[[\"@value\"],[[30,0,[\"newTagName\"]]]],null],[1,\"\\n\\n    \"],[8,[39,7],[[24,0,\"u--m__l__xs\"],[24,\"data-test-id\",\"post-tagging-rename-submit-button\"],[24,\"tabindex\",\"0\"]],[[\"@additional\",\"@onClick\",\"@variant\"],[\"circle\",[30,0,[\"handleSubmitRename\"]],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[10,1],[14,0,\"tag-name u--m__r__xs\"],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n\"]],[]]],[1,\"  \"],[8,[39,8],null,[[\"@horizontalPosition\",\"@onClose\",\"@onOpen\"],[\"right\",[30,0,[\"onDeleteDropdownClosed\"]],[30,0,[\"onDeleteDropdownOpen\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[8,[30,3,[\"Trigger\"]],[[24,\"data-test-id\",\"post-tagging-tag-item-actions-trigger\"],[24,\"tabindex\",\"-1\"],[4,[38,2],[\"click\",[30,0,[\"stopPropagation\"]]],null]],null,[[\"default\"],[[[[1,\"\\n\"],[41,[51,[30,0,[\"isRenaming\"]]],[[[1,\"        \"],[8,[39,7],[[24,0,\"cPT__text-primary\"]],[[\"@additional\",\"@variant\"],[\"circle\",[52,[30,0,[\"isRenaming\"]],\"mute\",\"unstyled\"]]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,3],[\"ellipsis-h\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n    \"],[8,[30,3,[\"Content\"]],[[24,0,\"cPT__tag-dropdown__content-delete\"],[24,\"data-test-id\",\"post-tagging-tag-item-actions-content\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,7],[[24,0,\"cPT__tag-dropdown__item cPT__text-primary\"],[24,\"data-test-id\",\"post-tagging-rename-button\"],[24,\"tabindex\",\"0\"]],[[\"@onClick\",\"@variant\"],[[28,[37,10],[[30,0,[\"onRenameClicked\"]],[30,3]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"edit\"],[[\"class\"],[\"o--icon cPT__icon u--m__r__sm\"]]]],[1,\"\\n        \"],[1,[28,[35,11],[\"post-tagging.tags.rename\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[8,[39,7],[[24,0,\"cPT__tag-dropdown__item cPT__text-primary\"],[24,\"data-test-id\",\"post-tagging-delete-button\"],[24,\"tabindex\",\"0\"]],[[\"@onClick\",\"@variant\"],[[28,[37,10],[[30,4],[30,1]],null],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,3],[\"trash\"],[[\"class\"],[\"o--icon cPT__icon u--m__r__sm\"]]]],[1,\"\\n        \"],[1,[28,[35,11],[\"post-tagging.tags.delete\"],null]],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"]],[]]]]],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"],[13]],[\"@tag\",\"@isSelected\",\"actionsDD\",\"@deleteTag\"],false,[\"if\",\"concat-classes\",\"on\",\"svg-jar\",\"shared/post-tagging/color-circle\",\"input\",\"autofocus\",\"shared/ui/button\",\"basic-dropdown\",\"unless\",\"fn\",\"t\"]]",
    "moduleName": "shared/components/shared/post-tagging/tag-dropdown-item.hbs",
    "isStrictMode": false
  });
  let TagDropdownItemComponent = _exports.default = (_class = class TagDropdownItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "newTagName", _descriptor, this);
      _initializerDefineProperty(this, "isRenaming", _descriptor2, this);
    }
    get isDisabled() {
      return this.args.isOverTagLimit;
    }
    clearRename() {
      this.newTagName = this.args.tag.name;
      this.isRenaming = false;
    }
    handleSubmitRename(e) {
      this.stopPropagation(e);
      const name = this.newTagName.trim();
      if (!name.length || name === this.args.tag.name) return this.clearRename();
      this.args.handleSubmitRename?.({
        ...this.args.tag,
        name
      });
      queueMicrotask(() => {
        this.clearRename();
      });
    }
    onRenameClicked(dropdown) {
      this.newTagName = this.args.tag.name;
      dropdown.actions.close();
      this.isRenaming = true;
    }
    handleRenameInput(e) {
      this.stopPropagation(e);
      if (e.key === 'Enter') {
        this.handleSubmitRename();
      } else if (e.key === 'Escape') {
        this.clearRename();
      } else {
        const target = e.target;
        this.newTagName = target.value;
      }
    }
    stopPropagation(e) {
      e?.stopPropagation();
    }
    onDeleteDropdownOpen(_, e) {
      this.stopPropagation(e);
    }
    onDeleteDropdownClosed(_, e) {
      if (!this.args.isDeleting) this.stopPropagation(e);
      return !this.args.isDeleting;
    }
    onTagItemKeydown(e) {
      if ((e.key === 'Enter' || e.key === ' ') && !this.isRenaming && !this.isDisabled) {
        this.args.onSelectTag(this.args.tag);
      }
    }
    onTagItemClicked() {
      if (!this.isRenaming && !this.isDisabled) this.args.onSelectTag(this.args.tag);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "newTagName", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return this.args.tag.name;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "isRenaming", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "clearRename", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "clearRename"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSubmitRename", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSubmitRename"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onRenameClicked", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onRenameClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleRenameInput", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "handleRenameInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stopPropagation", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "stopPropagation"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDeleteDropdownOpen", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDeleteDropdownOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onDeleteDropdownClosed", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onDeleteDropdownClosed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTagItemKeydown", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onTagItemKeydown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTagItemClicked", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onTagItemClicked"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, TagDropdownItemComponent);
});